export default "__VITE_ASSET__f6605b62__"